import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SupportIntegrationRoutingModule } from './support-integration-routing.module';
import { CardiSupportIntegrationModule } from '@pics-module/support-integration';
import { SupportIntegrationComponent } from './support-integration.component';

@NgModule({
    declarations: [
        SupportIntegrationComponent
    ],
    imports: [
        CommonModule,
        SupportIntegrationRoutingModule,
        CardiSupportIntegrationModule
    ],
})
export class SupportIntegrationModule {}
